import styled from 'styled-components';
import { StyledBadgeProps } from './types';

export const StyledBadge = styled.span<StyledBadgeProps>`
  display: flex;
  font-weight: 500;
  border-radius: var(--radius-100);
  width: ${(p) => (p.$iconOnly ? 'var(--spacing-xl)' : 'fit-content')};
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  position: relative;
  cursor: pointer;
  margin-right: var(--spacing-s);

  font-size: 12px;
  line-height: var(--spacing-l);
  height: var(--spacing-xl);
  padding: var(--spacing-s);

  color: var(--color-interface-secondary-lighter);
  background-color: var(--color-interface-neutral-light);
  border: 1px solid var(--color-interface-layout-normal);

  > svg,
  > img {
    margin-right: ${(p) => (p.$iconOnly ? 0 : '4px')};
    width: var(--spacing-l);
    height: var(--spacing-l);
  }

  &:disabled {
    pointer-events: none;
    background-color: var(--color-interface-layout-lighter);
    border: 1px solid var(--color-interface-layout-normal);
    color: var(--color-interface-layout-darkest);
  }
`;
